<template>
  <BaseDropdown
    v-model="value"
    :fieldId="fieldId"
    :fieldName="fieldId"
    :fieldLabel="fieldLabel"
    placeholder="Choose an accent"
    :options="ACCENT_OPTIONS"
    filter
  >
    <template #value="slotProps">
      <div class="flex align-items-center">
        {{ slotProps.value || slotProps.placeholder }}
        <Chip
          v-if="accentIsBeta"
          class="ml-1 text-xs py-0 bg-indigo-100"
          label="Beta"
        />
      </div>
    </template>
    <template #option="slotProps">
      {{ slotProps.option.label }}
      <Chip
        v-if="slotProps.option.isBeta"
        class="ml-2 text-xs py-0 bg-indigo-100"
        label="Beta"
      />
    </template>
  </BaseDropdown>
</template>

<script>
import { ACCENT_OPTIONS } from '@/constants';

export default {
  props: {
    modelValue: {
      validator: (prop) => typeof prop === 'string' || typeof prop === 'number',
    },
    fieldId: {
      type: String,
      default: 'accent',
    },
    fieldLabel: {
      type: String,
      default: 'Accent',
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    accentIsBeta() {
      if (!this.value) return false;

      const chosenAccent = ACCENT_OPTIONS.find((item) => item.value === this.value);

      return chosenAccent && chosenAccent.isBeta === true;
    },
  },
  data() {
    return {
      ACCENT_OPTIONS,
    };
  },
};
</script>
